import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MetadataService } from 'src/app/api/metadata.service';
import { LocaleService } from 'src/app/services/locale.service';
import { GeneralEvents } from 'src/app/models/tracking-analytics';
import { AmplitudeAnalyticsService } from 'src/app/services/amplitude-analytics.service';

@Component({
    selector: 'site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.scss'],
    standalone: false
})
export class SiteFooterComponent implements OnInit {
  @Input() displayDisclaimer: boolean = false;

  links = environment.links;
  currentLanguage: string;
  isAr: boolean;
  fiatCurrency: string;
  GeneralEvents = GeneralEvents;

  constructor(
    private metadata: MetadataService,
    private localeService: LocaleService,
    private amplitudeAnalytics: AmplitudeAnalyticsService
  ) { }

  ngOnInit() {
    this.currentLanguage = this.localeService.currentLocale;
    this.isAr = this.localeService.isArabic();
    this.getDefaultFiatCurrency();
  }

  get year() {
    return new Date().getFullYear();
  }

  getDefaultFiatCurrency() {
    this.metadata.userCurrency().subscribe(response => {
      this.setFiatCurrency(response);
    }, () => {
      this.setFiatCurrency(environment.currencies.defaultCurrency);
    });
  }

  setFiatCurrency(currency: string) {
    this.fiatCurrency = currency;
  }

  onAppDownloadClick(event: GeneralEvents){
    this.amplitudeAnalytics.SendTrack(event,{});
  }

}
